let currentETag = null

const POLL_INTERVAL_MS = 5 * 60 * 1000 // every 5 minutes

let onDeploymentDetected = null

export function setDeploymentCallback(callback) {
  onDeploymentDetected = callback
  // Expose a manual trigger for testing — run window.showDeploymentBanner() in console
  window.showDeploymentBanner = () => {
    if (onDeploymentDetected) onDeploymentDetected()
  }
}

export function startVersionPolling() {
  const poll = async () => {
    try {
      const res = await fetch('/index.html', {
        method: 'HEAD',
        cache: 'no-cache',
      })
      const etag = res.headers.get('etag') || res.headers.get('last-modified')
      if (etag) {
        if (currentETag && currentETag !== etag) {
          if (onDeploymentDetected) {
            onDeploymentDetected()
          }
        }
        currentETag = etag
      }
    } catch (e) {
      console.error('Error polling for new version:', e)
    }
  }

  // Initial fetch to set baseline
  poll()

  // Poll every 5 minutes to detect deployments
  return setInterval(poll, POLL_INTERVAL_MS)
}

export function handleChunkLoadErrors() {
  window.addEventListener('error', (event) => {
    if (
      event.message?.includes('Loading chunk') ||
      event.message?.includes('ChunkLoadError')
    ) {
      window.location.reload()
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason?.message?.includes('Loading chunk') ||
      event.reason?.name === 'ChunkLoadError'
    ) {
      window.location.reload()
    }
  })
}
